var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoreDetailsArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "#151B26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.31706 0.0766301C3.21347 -0.0234433 3.04836 -0.0205582 2.94829 0.083036C2.85068 0.184112 2.85068 0.344332 2.94829 0.445383L8.50122 5.99883L2.94777 11.5518C2.84418 11.6518 2.84132 11.8169 2.94137 11.9205C3.04144 12.0241 3.20653 12.027 3.31014 11.9269C3.31232 11.9248 3.31445 11.9227 3.31655 11.9205L9.05413 6.18296C9.15594 6.08113 9.15594 5.91604 9.05413 5.81419L3.31706 0.0766301Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13237 11.9971C2.98833 11.9973 2.87136 11.8808 2.87109 11.7367C2.87097 11.6673 2.89855 11.6007 2.94772 11.5516L8.50117 5.99869L2.94772 0.445776C2.84574 0.343796 2.84574 0.178466 2.94772 0.0764853C3.0497 -0.0254951 3.21503 -0.0254951 3.31701 0.0764853L9.05459 5.81406C9.1564 5.9159 9.1564 6.08098 9.05459 6.18284L3.31701 11.9204C3.26811 11.9695 3.20166 11.9971 3.13237 11.9971Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreDetailsArrowRight);
export default ForwardRef;